module.exports = __webpack_public_path__ + "images/e862d40fa5057c914cd0c4789013bb30-IMG_4680.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living/IMG_4680.jpg
// module id = ./src/assets/images/slides/living/IMG_4680.jpg
// module chunks = 0